function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Successfully accepted invite"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "This Activation Link Has Expired"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Activation links expire when:"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "Your account has already been activated"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "It has been over 14 days since the invitation was sent"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "The organizer has revoked the invitation"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "Back to Login"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "You’ve Accepted Your Invite!"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Accept Your Invite"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Accept Invite"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Login"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import React, { useEffect, useState } from "react";
import { Space, Button, Typography, message } from "antd";
import { t } from "ttag";
import * as Sentry from "@sentry/react";
import Layout from "./Layout";
import useInvite, { ERROR_MESSAGES } from "./useInvite";
var Title = Typography.Title, Paragraph = Typography.Paragraph;
var AcceptInvite = function(param) {
    var id = param.id, token = param.token, description = param.description, checkInviteStatusFn = param.checkInviteStatusFn, acceptInviteFn = param.acceptInviteFn, onLogin = param.onLogin, onAccept = param.onAccept;
    var _useState = _slicedToArray(useState(false), 2), isAccepted = _useState[0], setIsAccepted = _useState[1];
    var _useInvite = useInvite(token, id, checkInviteStatusFn, acceptInviteFn), isValidating = _useInvite.isValidating, status = _useInvite.status, accept = _useInvite.accept, isAcceptInProgress = _useInvite.isAcceptInProgress;
    useEffect(function() {
        if (status === null || status === void 0 ? void 0 : status.isInvitationAccepted) {
            onLogin();
        }
    }, [
        status,
        onLogin
    ]);
    var handleAcceptInvite = function() {
        var _ref = _asyncToGenerator(function() {
            var err;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!!status.isNewUser) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            accept()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        message.success(t(_templateObject()));
                        setIsAccepted(true);
                        onAccept === null || onAccept === void 0 ? void 0 : onAccept();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        message.error(ERROR_MESSAGES().somethingWentWrong);
                        Sentry.captureException(err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAcceptInvite() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isValidating || !status) {
        return null;
    }
    if (!status.isEmailTokenValid || status.isInvitationAccepted === null) {
        return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Space, {
            direction: "vertical",
            align: "center",
            size: "middle",
            style: {
                display: "flex"
            }
        }, /*#__PURE__*/ React.createElement(Space, {
            direction: "vertical",
            align: "center",
            size: "middle",
            style: {
                display: "flex"
            }
        }, /*#__PURE__*/ React.createElement(Title, {
            level: 3
        }, t(_templateObject1())), /*#__PURE__*/ React.createElement(Space, {
            direction: "vertical",
            size: "middle"
        }, /*#__PURE__*/ React.createElement(Paragraph, null, t(_templateObject2())), /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("li", null, t(_templateObject3())), /*#__PURE__*/ React.createElement("li", null, t(_templateObject4())), /*#__PURE__*/ React.createElement("li", null, t(_templateObject5()))))), /*#__PURE__*/ React.createElement(Button, {
            type: "primary",
            onClick: onLogin
        }, t(_templateObject6()))));
    }
    var title = isAccepted ? t(_templateObject7()) : t(_templateObject8());
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Space, {
        direction: "vertical",
        align: "center",
        size: "middle",
        style: {
            display: "flex"
        }
    }, /*#__PURE__*/ React.createElement(Space, {
        direction: "vertical",
        align: "center",
        size: "middle",
        style: {
            display: "flex"
        }
    }, /*#__PURE__*/ React.createElement(Title, {
        level: 3
    }, title), /*#__PURE__*/ React.createElement(Paragraph, {
        style: {
            textAlign: "center"
        }
    }, description)), !isAccepted && /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: handleAcceptInvite,
        disabled: isAcceptInProgress
    }, t(_templateObject9())), isAccepted && /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: onLogin
    }, t(_templateObject10()))));
};
export default AcceptInvite;
